import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-folder-open-line"></i>
            快速导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            分类索引
          </h2>
          <p className="text-foreground-500 text-sm mt-2">
            按类型找到你想看的韩漫
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, idx) => {
            const colors = [
              { bg: 'bg-primary-100', icon: 'text-primary-500' },
              { bg: 'bg-accent-100', icon: 'text-accent-500' },
              { bg: 'bg-secondary-100', icon: 'text-secondary-500' },
              { bg: 'bg-primary-100', icon: 'text-primary-500' },
              { bg: 'bg-accent-100', icon: 'text-accent-500' },
              { bg: 'bg-secondary-100', icon: 'text-secondary-500' },
              { bg: 'bg-primary-100', icon: 'text-primary-500' },
              { bg: 'bg-accent-100', icon: 'text-accent-500' },
            ];
            const c = colors[idx];

            return (
              <div
                key={item.id}
                className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 cursor-pointer hover:border-primary-200/50 transition-all flex items-start gap-4"
              >
                <div className={`w-11 h-11 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${c.bg}`}>
                  <i className={`${item.icon} text-xl ${c.icon}`}></i>
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                  <p className="text-[11px] text-foreground-400 mt-2">
                    {item.count} 部作品
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}